import { render, staticRenderFns } from "./BattleViewHandler.vue?vue&type=template&id=16dab6c7&"
import script from "./BattleViewHandler.vue?vue&type=script&lang=ts&"
export * from "./BattleViewHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports